import axios from 'axios'
export default {
  getInstance (env , opt = {}, forceEnv = false) {
    try {
      let ENV = 'dev' //(forceEnv) ? env : process.env.NODE_ENV || env
      let baseUrl = process.env.REACT_APP_API_ENDPOINT
      let token = process.env.REACT_APP_TOKEN
    return axios.create({
        baseURL: baseUrl,
        timeout: Number(30 * 1000),
        responseType: 'json',
        headers: {
          'Content-Type': 'application/json, text/plain',
          'X-API-KEY': token,
          'Accept': '*/*'
        },
        withCredentials: false,
        crossDomain: true
      })
    } catch (error) {
      console.error('getAxiosInstance Error->', error.message)
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/axios.js